import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import css from './InquiryWizardSection.module.css';

const InquiryWizardSection = ({ className, rootClassName, children }) => {
  const classes = classNames(rootClassName || css.root, className);

  return <div className={classes}>{children}</div>;
};

InquiryWizardSection.defaultProps = {
  className: null,
  rootClassName: null,
};

InquiryWizardSection.propTypes = {
  className: string,
  rootClassName: string,
};

export default InquiryWizardSection;
